import React, {PureComponent} from "react";
import {Table} from "reactstrap";
import {withTranslation} from "react-i18next";
import UserInfo from "../components/UserInfo";
import {map} from "lodash";

class NotificationDetails extends PureComponent {
  render() {
    const {t, notification} = this.props;
    const {creator, priority, actionFlow} = notification;
    return (
      <div className="table-row-sub p-2">
        <Table bordered responsive className="flex-1">
          <tbody>
            <tr>
              <td style={{width: 150}} className="text-info">{t("Creator")}</td>
              <td className="py-1">
                <UserInfo
                  textColor="text-dark"
                  label={creator.type === "ADMIN" ? t('Admin') : t("System")}
                  id={creator.value}
                  type={creator.type}
                />
              </td>
            </tr>
            {!!priority &&
              <tr>
                <td style={{width: 150}} className="text-info">{t("Send Priority")}</td>
                <td className="py-1">{priority}</td>
              </tr>
            }
          </tbody>
        </Table>
        {map(actionFlow, item => (
          <div className="d-flex flex-row" key={item.channel}>
            {Object.keys(item.presentation.message).length > 0 &&
              <div className="flex-1 mr-2 mt-2">
                <div className="font-weight-semibold mb-2">
                  {t("Display Info In {{name}} Channel", {name: item.channel})}:
                </div>
                <Table bordered responsive className="w-100">
                  <tbody>
                  {map(item.presentation.message, (value, key) => (
                    typeof value !== "object" ?
                      <tr key={key}>
                        <td style={{width: 150}} className="text-info">{key}</td>
                        <td className="py-1">{value}</td>
                      </tr> :
                      null
                  ))}
                  </tbody>
                </Table>
              </div>
            }
            {Object.keys(item.presentation.data).length > 0 &&
              <div className="flex-1 mt-2">
                <div className="font-weight-semibold mb-2">
                  {t("Meta Info In {{name}} Channel", {name: item.channel})}:
                </div>
                <Table bordered responsive className="w-100">
                  <tbody>
                  {map(item.presentation.data, (value, key) => (
                    typeof value !== "object" ?
                      <tr key={key}>
                        <td style={{width: 150}} className="text-info">{key}</td>
                        <td className="py-1">{value}</td>
                      </tr> :
                      null
                  ))}
                  </tbody>
                </Table>
              </div>
            }
          </div>
        ))}
      </div>
    );
  }
}

export default withTranslation()(NotificationDetails);